import { createContext } from "react"

import { AppContextType } from "./src/Puzzmo"

export const AppContext = createContext<AppContextType>({} as any)
